// @flow
import type { RouterHistory } from "react-router";
import type { Middleware } from "redux";
import type {
  ReduxAction,
  ReduxState,
  Dispatch,
  PossibleAction,
} from "../types";

/**
 */
export const routerMiddleware =
  (history: RouterHistory): Middleware<ReduxState, ReduxAction, Dispatch> =>
  () =>
  (next: Dispatch) =>
  (action: PossibleAction) => {
    if (action.type === "ROUTER/PUSH") {
      // $FlowExpectedError[prop-missing]
      const { location, state } = action.payload;
      history.push(location, state);
    } else if (action.type === "ROUTER/REPLACE") {
      // $FlowExpectedError[prop-missing]
      const { location, state } = action.payload;
      history.replace(location, state);
    } else if (action.type === "ROUTER/GO") {
      // $FlowExpectedError[prop-missing]
      const { delta } = action.payload;
      history.go(delta);
    } else if (action.type === "ROUTER/GOBACK") {
      history.goBack();
    } else if (action.type === "ROUTER/GOFORWARD") {
      history.goForward();
    }

    return next(action);
  };
